module.exports = __webpack_public_path__ + "files/057e509da30a06ac7dc5a43c51a273a9.png";